export const Edit = "EDIT";
export const Create = "CREATE";